import React, { useEffect, useState } from "react"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Action } from "@tenforce/toolbox-button-push-react"
import {
    Block,
    Item,
    ItemBlock,
    Part,
    Selector,
} from "@tenforce/toolbox-selector-react"
import ContextMenu from "../../../../common/contextmenu/components/ContextMenu"

import ShareButton from "../../../../common/resource/ShareButton"
import { useAppSelector } from "../../../../../hooks"

import ContextMenuAction from "../../../../common/contextmenu/components/ContextMenuAction"
import {
    findDeleteButton,
    findOptionalCustomButtons,
    findOptionalStandardButtons,
    findPrimaryButtons,
} from "./helper"

import "./../Header.scss"
import { Labels } from "../../../../../util/Translations"

const ItemDetailHeaderActions: React.FC = () => {
    const { item, pageHeader, buttons } = useAppSelector(
        (state) => state.itemDetail,
    )

    const [isContextModalShown, setIsContextModalShown] = useState(false)
    const [optionalStandardActionButtons, setOptionalStandardActionButtons] =
        useState<Button[]>([])
    const [optionalCustomActionButtons, setOptionalCustomActionButtons] =
        useState<Button[]>([])

    const [deleteButton, setDeleteButton] = useState<Button | null>(null)
    const [primaryActionButtons, setPrimaryActionButtons] = useState<Button[]>(
        [],
    )

    useEffect(() => {
        setDeleteButton(findDeleteButton(buttons))
        setPrimaryActionButtons(findPrimaryButtons(buttons))
        setOptionalStandardActionButtons(findOptionalStandardButtons(buttons))
        setOptionalCustomActionButtons(findOptionalCustomButtons(buttons))
    }, [buttons])

    const { ItemDetailsCopiedToClipboard, ShareButtonTooltip } = Labels

    return (
        <>
            <div className="header">
                {primaryActionButtons.map((button) => (
                    <ContextMenuAction
                        button={button}
                        key={button.uuid}
                        executeCallAction={(): void => {
                            console.info("not implemented")
                        }}
                    />
                ))}
            </div>
            <Item data-testid="status" isSelected={true}>
                <Block>
                    <Part>{item.status?.label}</Part>
                </Block>
            </Item>

            <ShareButton
                buttonId={`shareButton${item.id}`}
                resourceTitle={`${item.number ? `(${item.number}) ` : ""}${
                    pageHeader.title?.value
                }`}
                showCaption={false}
                successMessage={ItemDetailsCopiedToClipboard}
                tooltip={ShareButtonTooltip}
                url={window.location.href}
            />
            {/* placeholder */}
            <Action title="bookmark">{Symbols.BookmarkEmpty}</Action>
            {/* placeholder */}
            <ContextMenu
                buttonId="optionalHeaderButtonsButton"
                hideModal={(): void => {
                    setIsContextModalShown(false)
                }}
                isModalShown={isContextModalShown}
                modalId="optionalHeaderButtonsModal"
                showModal={(): void => {
                    setIsContextModalShown(true)
                }}
            >
                <div className="tw-py-2">
                    {optionalCustomActionButtons.map((button) => (
                        <ContextMenuAction
                            button={button}
                            executeCallAction={(): void => {
                                console.log("not implemented")
                            }}
                            extraClasses="tw-py-2 tw-px-4"
                            key={button.uuid}
                        />
                    ))}
                    {optionalCustomActionButtons.length > 0 && (
                        <div className="separator-line is-dotted is-dimmed tw-py-2" />
                    )}
                    {optionalStandardActionButtons.map((button) => (
                        <ContextMenuAction
                            button={button}
                            executeCallAction={(): void => {
                                console.log("not implemented")
                            }}
                            extraClasses="tw-py-2 tw-px-4"
                            key={button.uuid}
                        />
                    ))}
                    {!!deleteButton && (
                        <>
                            <div className="separator-line is-dotted is-dimmed tw-py-2" />
                            <ContextMenuAction
                                button={deleteButton}
                                executeCallAction={(): void => {
                                    console.log("not implemented")
                                }}
                                extraClasses="tw-py-2 tw-px-4"
                                key={deleteButton.uuid}
                            />
                        </>
                    )}
                </div>
            </ContextMenu>
            {/* placeholder */}
            <Selector isSingleSelect={false} isExpanded={true}>
                <ItemBlock>
                    <Part>{Symbols.Process}</Part>
                </ItemBlock>
                <ItemBlock>
                    <Part>{Symbols.CommentsAndAttachments}</Part>
                </ItemBlock>
            </Selector>
        </>
    )
}
export default ItemDetailHeaderActions
